declare function require(moduleName: string): any;

const {version : appVersion} = require('../../package.json');
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const fromEnv = (key: string) => {
    const env = (window as any).env;
    if(!(key in env))     {
        throw new Error(`Could not read environment variable ${key}`);
    }
    return env[key];
};

const fromEnvBoolean = (key: string) => {
    const value = fromEnv(key);
    return value === true || value === 'true';
};

export const environment  = {
  production: fromEnv('production') === 'true',
  baseHref: fromEnv('baseHref'),
  apiBaseUrl: fromEnv('apiBaseUrl'),
  authenticationBaseUrl: fromEnv('authenticationBaseUrl'),
  officeAppUrl: fromEnv('officeAppUrl'),
  adTenant: fromEnv('adTenant'),
  adClientId: fromEnv('adClientId'),
  seqLoggingEndpoint: fromEnv('seqLoggingEndpoint'),
  seqLoggingApiKey: fromEnv('seqLoggingApiKey'),
  appVersion: fromEnv('appVersion'),
  paymentsProcessorOfficeApiUrl: fromEnv('paymentsProcessorOfficeApiUrl'),
  adRedirectUri: fromEnv('adRedirectUri'),
  officeApiScope: fromEnv('officeApiScope'),
  paymentsProcessorOfficeApiScope: fromEnv('paymentsProcessorOfficeApiScope'),
  observabilityEnabled: fromEnvBoolean('observabilityEnabled'),
  environment: fromEnv('environment'),
  observabilityServiceName: fromEnv('observabilityServiceName'),
  observabilityServiceNamespace: fromEnv('observabilityServiceNamespace'),
};
